// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d7vyU","col":"styles_col__3KLtC"};